function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeWidth: 4,
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#23C386",
  d: "M35 26.25v-7.51a4.56 4.56 0 00-4.56-4.56h-9.09a4.57 4.57 0 00-4.47 3.64v1.81"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeLinejoin: "round",
  d: "M18.86 26.25V24a4.56 4.56 0 00-4.56-4.56H5.18A4.56 4.56 0 00.62 24v2.28"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 9.74,
  cy: 10.3,
  r: 4.56,
  stroke: "#333",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25.95,
  cy: 5.06,
  r: 4.56,
  stroke: "#23C386"
}));

function SvgTeam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39 29"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzOSAyOSI+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIgMikiPgogICAgPHBhdGggc3Ryb2tlPSIjMjNDMzg2IiBkPSJNMzUsMjYuMjUgTDM1LDE4Ljc0IEMzNSwxNi4yMjE1ODE1IDMyLjk1ODQxODUsMTQuMTggMzAuNDQsMTQuMTggTDIxLjM1LDE0LjE4IEMxOS4xODYxNDkyLDE0LjE4MjA3MDEgMTcuMzIwMzQ1MiwxNS43MDE0MjcyIDE2Ljg4LDE3LjgyIEwxNi44OCwxOS42MyIvPgogICAgPHBhdGggc3Ryb2tlPSIjMzMzIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBkPSJNMTguODYsMjYuMjUgTDE4Ljg2LDI0IEMxOC44NiwyMS40ODE1ODE1IDE2LjgxODQxODUsMTkuNDQgMTQuMywxOS40NCBMNS4xOCwxOS40NCBDMi42NjE1ODE1NCwxOS40NCAwLjYyLDIxLjQ4MTU4MTUgMC42MiwyNCBMMC42MiwyNi4yOCIvPgogICAgPGNpcmNsZSBjeD0iOS43NCIgY3k9IjEwLjMiIHI9IjQuNTYiIHN0cm9rZT0iIzMzMyIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgogICAgPGNpcmNsZSBjeD0iMjUuOTUiIGN5PSI1LjA2IiByPSI0LjU2IiBzdHJva2U9IiMyM0MzODYiLz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgTeam as ReactComponent };